<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">О нас</div>

            <div class="panel-body">


                <!--
                <div class="loader" v-show="!loaded"></div>

                <div class="row" v-show="loaded">
                    <div class="col-md-8">
                        Параметры
                    </div>
                    <div class="col-md-4">
                        ===
                    </div>
                </div>
                -->

                <form>
                    <div class="row">
                        <div class="col-xs-12">
                        <div class="form-group">
                            <label for="seo_title">Title</label>
                            <input type="text" id="seo_title" class="form-control" v-model="data.seo_title" />
                        </div>
                        <div class="form-group">
                            <label for="seo_description">Description</label>
                            <input type="text" id="seo_description" class="form-control" v-model="data.seo_description" />
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <div class="form-group">
                                <label for="img1">Изображение 1</label>
                                <div class="image-wrap" :style="{backgroundImage: 'url('+url+data.img1+')'}">
                                    <span v-show="!data.img1">Изображение отсутствует (желательный размер 675x380)</span>
                                </div>
                                <input type="file" id="img1">
                                <p class="help-block">Выберите изображение для загрузки (675x380 jpg,png)</p>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="form-group">
                                <label for="text1">Текст 1</label>
                                <textarea id="text1" class="form-control" rows="14" v-model="data.text1"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6">
                            <div class="form-group">
                                <label for="text2">Текст 2</label>
                                <textarea id="text2" class="form-control" rows="14" v-model="data.text2"></textarea>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="form-group">
                                <label for="img2">Изображение 2</label>
                                <div class="image-wrap" :style="{backgroundImage: 'url('+url+data.img2+')'}">
                                    <span v-show="!data.img2">Изображение отсутствует (желательный размер 675x380)</span>
                                </div>
                                <input type="file" id="img2">
                                <p class="help-block">Выберите изображение для загрузки (675x380 jpg,png)</p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6">
                            <div class="checkbox" style="margin-top:35px;">
                                <label>
                                    <input type="checkbox" v-model="data.pdf_show">
                                    Показывать ссылку на банкетное меню
                                </label>
                            </div>
                            <div class="form-group">
                                <label for="pdf">Банкетное меню</label>
                                <a :href="url+data.pdf" v-show="data.pdf" download>скачать</a>
                                <input type="file" id="pdf">
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-default" @click.prevent="store()">Сохранить</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {api} from '../http'
    var config = require('../config')

    export default {
      mounted () {
      },
      data () {
        return {
          url: config.appUrl,
          loaded: false,
          data: []
        }
      },
      beforeCreate () {
        this.loaded = false
        api.post('settings/fetchAboutPage').then(response => {
          this.loaded = true
          this.data = response.data
        })
      },
      methods: {
        store () {
          var formData = new FormData()

          formData.append('seo_title', this.data.seo_title)
          formData.append('seo_description', this.data.seo_description)
          formData.append('text1', this.data.text1)
          formData.append('text2', this.data.text2)
          formData.append('pdf_show', this.data.pdf_show)

          if (document.querySelector('#img1').files.length) {
            var file1 = document.querySelector('#img1').files[0]
            formData.append('img1', file1)
          }

          if (document.querySelector('#img2').files.length) {
            var file2 = document.querySelector('#img2').files[0]
            formData.append('img2', file2)
          }

          if (document.querySelector('#pdf').files.length) {
            var pdf = document.querySelector('#pdf').files[0]
            formData.append('pdf', pdf)
          }

          api.post('settings/storeAboutPage', formData).then(response => {
            if (response.data.success) {
              this.data = response.data.data
            } else {
              // this.modalError = response.data.message
            }
          })
        }
      }
    }
</script>

<style>
    .image-wrap {
        width: 370px;
        height: 248px;
        background-size: cover;
        border: 1px solid silver;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .slider-text {
        width: 450px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings/AdminSettingsAbout.vue